// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.competition-edit[data-v-7e44267f] {\n    margin-left: 0;\n}\n@media (min-width: 992px) {\n.competition-edit[data-v-7e44267f] {\n        margin-left: 30px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
